import { render } from "./index.vue?vue&type=template&id=18929c26&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=18929c26&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=18929c26&lang=scss"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18929c26"],['__file',"src/components/SimpleSlider/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18929c26"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18929c26', __exports__)) {
    console.log('reload')
    api.reload('18929c26', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=18929c26&scoped=true", () => {
    console.log('re-render')
    api.rerender('18929c26', render)
  })

}


export default __exports__